import React, { PropsWithChildren, useState } from 'react';

interface IProps {
  arrowClassName?: string;
  className?: string;
  content: React.ReactNode;
  contentClassName?: string;
  contentComponent?: React.FC<any>;
  hideTitleOnOpen?: boolean;
  title: React.ReactNode;
  titleClassName?: string;
  titleComponent?: React.FC<any>;
  onContentClick?(): void;
  onTitleClick?(): void;
}

const DefaultComponent = ({ className, onClick, content }) => (
  <div className={className} onClick={onClick}>
    {content}
  </div>
);

const showTitle = (open, hideTitleOnOpen) => {
  return open ? !hideTitleOnOpen : true;
};

const Collapsible = ({
  className,
  content,
  contentClassName,
  hideTitleOnOpen,
  title,
  titleClassName,
  onContentClick = R.F,
  onTitleClick = R.F,
  contentComponent: ContentComponent = DefaultComponent,
  titleComponent: TitleComponent = DefaultComponent,
}: PropsWithChildren<IProps>) => {
  const [open, setOpen] = useState(false);

  const handleTitleClick = () => {
    setOpen(R.not);
    onTitleClick();
  };

  const handleContentClick = () => {
    setOpen(R.not);
    onContentClick();
  };

  return (
    <div className={className}>
      {showTitle(open, hideTitleOnOpen) && (
        <TitleComponent
          className={classnames(open && 'open', titleClassName)}
          onClick={handleTitleClick}
          content={title}
        />
      )}
      {open && (
        <ContentComponent
          className={contentClassName}
          onClick={handleContentClick}
          content={content}
        />
      )}
    </div>
  );
};

export default Collapsible;
